// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/@zxcabs/rtl-css-loader/index.js?dirTagName=body&diff=true!../../../../node_modules/sass-loader/dist/cjs.js??ref--3-2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AccessPopup.vue?vue&type=style&index=0&id=785c5a53&lang=scss&scoped=true&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("3f0c62c4", content, true, {});